import * as Yup from 'yup';
import { maxDatePicker, minDatePicker } from '../../../utils/Constant';

export const TableColumns = [
  // { key: 'sn', label: 'SN' },
  { key: 'action', label: 'Action' },
  { key: 'isMailSent', label: 'New' },
  { key: 'custId', label: 'Cust #' },
  { key: 'kitNumber', label: 'Kit #' },
  { key: 'reportDate', label: 'Report Date' },
  { key: 'serialNumber', label: 'Serial #' },
  { key: 'compSerialNumber', label: 'Comp. Serial #' },
  { key: 'component', label: 'Component' },
  { key: 'location', label: 'Location' },
  { key: 'sampleNumber', label: 'Sample #' },
  { key: 'reportNumber', label: 'Report #' },
  { key: 'date', label: 'Date' },
];

export enum MainFormFields {
  TaiReportNumber = 'taiReportNumber',
  SampleNumber = 'sampleNumber',
  ReportDate = 'reportDate',
  SerialNumber = 'serialNumber',
  DateReceived = 'dateRecieved',
  Location = 'location',
  DateDrawn = 'dateDrawn',
  UnitMake = 'unitMake',
  UnitModel = 'unitModel',
  DateTested = 'dateTested',
  CustomerNumber = 'customerNumber',
  Manufacturer = 'manufacturer',
  Model = 'model',
  KitNumber = 'kitNumber',
  UnitNumber = 'unitNumber',
  CompanySerialNumber = 'companySerialNumber',
  Component = 'component',
}

export enum ConcentrationFields {
  Silicon = 'silicon',
  SiliconSEV = 'siliconSEV',
  Iron = 'iron',
  IronSEV = 'ironSEV',
  Chromium = 'chromium',
  ChromiumSEV = 'chromiumSEV',
  Aluminium = 'aluminium',
  AluminiumSEV = 'aluminiumSEV',
  Copper = 'copper',
  CopperSEV = 'copperSEV',
  Lead = 'lead',
  LeadSEV = 'leadSEV',
  Tin = 'tin',
  TinSEV = 'tinSEV',
  Nickel = 'nickel',
  NickelSEV = 'nickelSEV',
  Molybdenum = 'molybdenum',
  MolybdenumSEV = 'molybdenumSEV',
  Magnesium = 'magnesium',
  MagnesiumSEV = 'magnesiumSEV',
  Sodium = 'sodium',
  SodiumSEV = 'sodiumSEV',
  Boron = 'boron',
  BoronSEV = 'boronSEV',
  Barium = 'barium',
  BariumSEV = 'bariumSEV',
  Phosphorus = 'phosphorus',
  PhosphorusSEV = 'phosphorusSEV',
  Calcium = 'calcium',
  CalciumSEV = 'calciumSEV',
  Visc = 'visc',
  ViscSEV = 'viscSEV',
  Zinc = 'zinc',
  ZincSEV = 'zincSEV',
  WaterKF = 'waterKF',
  WaterKFSEV = 'waterKFSEV',
  TAN = 'tan',
  TANSEV = 'tanSEV',
  Potassium = 'potassium',
  PotassiumSEV = 'potassiumSEV',
  Manganese = 'manganese',
  ManganeseSEV = 'manganeseSEV',
  Titanium = 'titanium',
  TitaniumSEV = 'titaniumSEV',
  Vanadium = 'vanadium',
  VanadiumSEV = 'vanadiumSEV',
  Silver = 'silver',
  SilverSEV = 'silverSEV',
}

export enum ResultFields {
  OilChanged = 'oilChanged',
  FluidType = 'fluidType',
  FluidBrand = 'fluidBrand',
  FluidGrade = 'fluidGrade',
  MHMRUnit = 'mhMrUnit',
  CompAge = 'compAge',
  FilterAge = 'filterAge',
  MhOil = 'mhOil',
  OilAdded = 'oilAdded',
  Condition = 'condition',
  Result = 'result',
}

export const ResultFieldLabel = {
  [ResultFields.OilChanged]: 'Oil Changed',
  [ResultFields.FluidType]: 'Fluid Type',
  [ResultFields.FluidBrand]: 'Fluid Brand',
  [ResultFields.FluidGrade]: 'Fluid Grade',
  [ResultFields.MHMRUnit]: 'MH/MR Unit',
  [ResultFields.CompAge]: 'Comp Age',
  [ResultFields.FilterAge]: 'Filter Age',
  [ResultFields.MhOil]: 'MH Oil',
  [ResultFields.OilAdded]: 'Oil Added',
  [ResultFields.Condition]: 'Condition',
  [ResultFields.Result]: 'Result',
};

export const ConcentrationLabel = {
  [ConcentrationFields.Silicon]: 'Silicon',
  [ConcentrationFields.SiliconSEV]: 'Silicon_SEV',
  [ConcentrationFields.Iron]: 'Iron',
  [ConcentrationFields.IronSEV]: 'Iron_SEV',
  [ConcentrationFields.Chromium]: 'Chromium',
  [ConcentrationFields.ChromiumSEV]: 'Chromium_SEV',
  [ConcentrationFields.Aluminium]: 'Aluminium',
  [ConcentrationFields.AluminiumSEV]: 'Aluminium_SEV',
  [ConcentrationFields.Copper]: 'Copper',
  [ConcentrationFields.CopperSEV]: 'Copper_SEV',
  [ConcentrationFields.Lead]: 'Lead',
  [ConcentrationFields.LeadSEV]: 'Lead_SEV',
  [ConcentrationFields.Tin]: 'Tin',
  [ConcentrationFields.TinSEV]: 'Tin_SEV',
  [ConcentrationFields.Nickel]: 'Nickel',
  [ConcentrationFields.NickelSEV]: 'Nickel_SEV',
  [ConcentrationFields.Molybdenum]: 'Molybdenum',
  [ConcentrationFields.MolybdenumSEV]: 'Molybdenum_SEV',
  [ConcentrationFields.Magnesium]: 'Magnesium',
  [ConcentrationFields.MagnesiumSEV]: 'Magnesium_SEV',
  [ConcentrationFields.Sodium]: 'Sodium',
  [ConcentrationFields.SodiumSEV]: 'Sodium_SEV',
  [ConcentrationFields.Boron]: 'Boron',
  [ConcentrationFields.BoronSEV]: 'Boron_SEV',
  [ConcentrationFields.Barium]: 'Barium',
  [ConcentrationFields.BariumSEV]: 'Barium_SEV',
  [ConcentrationFields.Phosphorus]: 'Phosphorus',
  [ConcentrationFields.PhosphorusSEV]: 'Phosphorus_SEV',
  [ConcentrationFields.Calcium]: 'Calcium',
  [ConcentrationFields.CalciumSEV]: 'Calcium_SEV',
  [ConcentrationFields.Visc]: 'Visc',
  [ConcentrationFields.ViscSEV]: 'Visc_SEV',
  [ConcentrationFields.Zinc]: 'Zinc',
  [ConcentrationFields.ZincSEV]: 'Zinc_SEV',
  [ConcentrationFields.WaterKF]: 'Water KF',
  [ConcentrationFields.WaterKFSEV]: 'Water KF_SEV',
  [ConcentrationFields.TAN]: 'TAN',
  [ConcentrationFields.TANSEV]: 'TAN_SEV',
  [ConcentrationFields.Potassium]: 'Potassium',
  [ConcentrationFields.PotassiumSEV]: 'Potassium_SEV',
  [ConcentrationFields.Manganese]: 'Manganese',
  [ConcentrationFields.ManganeseSEV]: 'Manganese_SEV',
  [ConcentrationFields.Titanium]: 'Titanium',
  [ConcentrationFields.TitaniumSEV]: 'Titanium_SEV',
  [ConcentrationFields.Vanadium]: 'Vanadium',
  [ConcentrationFields.VanadiumSEV]: 'Vanadium_SEV',
  [ConcentrationFields.Silver]: 'Silver',
  [ConcentrationFields.SilverSEV]: 'Silver_SEV',
};

export const MainFormLabel = {
  [MainFormFields.TaiReportNumber]: 'TAI Report #',
  [MainFormFields.SampleNumber]: 'Sample #',
  [MainFormFields.ReportDate]: 'Report Date',
  [MainFormFields.SerialNumber]: 'Serial # (Unit Id)',
  [MainFormFields.DateReceived]: 'Date Received',
  [MainFormFields.Location]: 'Location',
  [MainFormFields.DateDrawn]: 'Date Drawn',
  [MainFormFields.UnitMake]: 'Unit Make',
  [MainFormFields.UnitModel]: 'Unit Model',
  [MainFormFields.DateTested]: 'Date Tested',
  [MainFormFields.CustomerNumber]: 'Customer #',
  [MainFormFields.Manufacturer]: 'Manufacturer',
  [MainFormFields.Model]: 'Model',
  [MainFormFields.KitNumber]: 'Kit #',
  [MainFormFields.UnitNumber]: 'Unit # (Unit Serial No.)',
  [MainFormFields.CompanySerialNumber]: 'Compartment Serial #',
  [MainFormFields.Component]: 'Component',
};

export const MainFormSchema = Yup.object({
  [MainFormFields.ReportDate]: Yup.date().min(minDatePicker).max(maxDatePicker),
  [MainFormFields.DateReceived]: Yup.date().min(minDatePicker).max(maxDatePicker),
  [MainFormFields.DateDrawn]: Yup.date().min(minDatePicker).max(maxDatePicker),
  [MainFormFields.DateTested]: Yup.date().min(minDatePicker).max(maxDatePicker),
});

export const severities = [
  { Text: 'N', Value: 'N' },
  { Text: 'C', Value: 'C' },
  { Text: 'S', Value: 'S' },
  { Text: 'A', Value: 'A' },
  { Text: 'D', Value: 'D' },
  { Text: 'O', Value: 'O' },
];
